import React from 'react';
import { FaHome } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const NavLinks = () => {
    return (
        <div className="navLinks ">
        <NavLink to="/" className="link">
          <div className="icon">
            
          </div>
          <div
            
            className="link_text flex items-center justify-center "
          >
          <FaHome
          className='mr-2'
          />  Home
          </div>
        </NavLink>
        <NavLink to="/about" className="link">
          <div className="icon">
           
          </div>
          <div
          
            className="link_text"
          >
            About Me
          </div>
        </NavLink>
        <NavLink to="/resume" className="link">
          <div className="icon">
          
          </div>
          <div
           
            className="link_text"
          >
            Resume
          </div>
        </NavLink>
        <NavLink to="/portfolio" className="link">
          <div className="icon">
       
          </div>
          <div
           
            className="link_text"
          >
            portfolio
          </div>
        </NavLink>

        <NavLink to="/blogs" className="link">
          <div className="icon">
       
          </div>
          <div
           
            className="link_text"
          >
            Blogs
          </div>
        </NavLink>

        <NavLink to="/contact" className="link">
          <div className="icon">
          
          </div>
          <div
          
            className="link_text"
          >
            Contact
          </div>
        </NavLink>
        </div>
    );
};

export default NavLinks;